module.exports = __webpack_public_path__ + "static/media/blodet.e62a88c8.png";